'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Error fallback component for chunk loading failures
const ChunkErrorFallback = () => (
  <div className="w-full bg-red-50 border border-red-200 rounded-lg p-8 text-center">
    <h3 className="text-lg font-semibold text-red-900 mb-2">
      Calculator Update Available
    </h3>
    <p className="text-red-700 mb-4">
      A new version of the calculator has been deployed. Please refresh the page to load the latest version.
    </p>
    <button
      onClick={() => window.location.reload()}
      className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 transition-colors"
    >
      Refresh Page
    </button>
  </div>
);

const MortgageCalculatorComponent = dynamic(
  () => import('../tools/mortgage-calculator/MortgageMarketingROICalculator')
    .catch((err) => {
      // Log the error for debugging
      console.error('Failed to load mortgage calculator chunk:', err);

      // Return a component that shows the error state
      return { default: ChunkErrorFallback };
    }),
  {
    ssr: false,
    loading: () => (
      <div className="w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-3/4 mx-auto mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto mb-8"></div>
          <div className="space-y-4">
            <div className="h-12 bg-gray-100 rounded"></div>
            <div className="h-12 bg-gray-100 rounded"></div>
            <div className="h-12 bg-gray-100 rounded"></div>
          </div>
        </div>
        <p className="mt-4 text-gray-600">Loading calculator...</p>
      </div>
    )
  }
);

// Wrapper component that adds the ID for scroll targeting
const LazyMortgageCalculator: React.FC = (props) => {
  return (
    <div id="mortgage-calculator-container">
      <MortgageCalculatorComponent {...props} />
    </div>
  );
};

export default LazyMortgageCalculator;